import React, { useState, useCallback, useEffect } from 'react';

import moment from 'moment';
import ReactDataGrid from '@inovua/reactdatagrid-community';
import '@inovua/reactdatagrid-community/index.css';
import 'jspdf-autotable';
import 'assets/css/table.css';

function FormTable({ data, setListeSelect, setTotalImpute, totalMontantImpute, idreglement }) {
    window.moment = moment;
    // console.log(data);
    const [gridRef, setGridRef] = useState(null);
    const filterValue = [{ name: 'nofact', operator: 'contains', type: 'string', value: '' }];
    function numberformat(data) {
        return new Intl.NumberFormat().format(data);
    }
    const columnss = [
        {
            name: 'id',
            header: 'Id',
            defaultVisible: false,
            defaultWidth: 80,
            type: 'number'
        },
        {
            name: 'nofact',
            header: 'N° Facture',
            defaultWidth: 150,
            type: 'string',
            editable: false
            // render: ({ value, data }) => <p id={data.etat == 0 || data.etat == undefined ? 'successs' : 'success'}>{data.qrbarre}</p>
        },
        {
            name: 'datefact',
            header: 'Date Facture',
            defaultWidth: 180,
            type: 'string',
            editable: false,
            render: ({ value }) => moment(value).format('DD-MM-YYYY')
        },
        {
            name: 'montantfacture',
            header: 'Montant TTC',
            defaultWidth: 130,
            type: 'string',
            editable: false,
            render: ({ data }) => numberformat(data.montantfacture?.[2] || 0)
        },
        {
            name: 'montantreglemnt',
            header: 'Mont. payé',
            defaultWidth: 130,
            type: 'string',
            editable: false,
            render: ({ data }) => numberformat(data?.montantreglemnt || 0)
        },
        {
            // name: 'Reste à payer',
            header: 'Reste à payer',
            defaultWidth: 130,
            type: 'string',
            editable: false,
            render: ({ data }) => numberformat((data.montantfacture?.[2] || data.montantfacture) - data.montantreglemnt)
        },
        {
            name: 'montant_impute',
            header: 'Mont. imputé',
            textAlign: 'center',
            defaultWidth: 130,
            type: 'string',
            editable: true
        }
    ];

    const gridStyle = { minHeight: window.screen.height - 200 };

    const isStartEditKeyPressed = ({ event }) => event.key === 'k' && event.ctrlKey;

    const onEditComplete = useCallback(
        ({ value, columnId, rowId }) => {
            const dat = [...data];
            // console.table(value, columnId, rowId);
            if (value !== undefined && value >= 0) {
                const isLargeNumber = (element) => element.id === rowId;
                let mont = 0;
                if (typeof data[dat.findIndex(isLargeNumber)].montantfacture === 'object') {
                    mont = data[dat.findIndex(isLargeNumber)].montantfacture[2];
                } else {
                    mont = data[dat.findIndex(isLargeNumber)].montantfacture;
                }
                console.log(mont);
                if (mont - data[dat.findIndex(isLargeNumber)].montantreglemnt >= value) {
                    data[dat.findIndex(isLargeNumber)].montant_impute = value;
                } else {
                    if (idreglement) {
                        if (
                            mont - data[dat.findIndex(isLargeNumber)].montantreglemnt + data[dat.findIndex(isLargeNumber)].montant_impute >=
                            value
                        ) {
                            data[dat.findIndex(isLargeNumber)].montant_impute = value;
                            return;
                        }
                    }
                    alert('Le montant imputé ne peut pas être supérieur au reste à payer.');
                    return;
                }
            }
            setListeSelect(dat);
            const totalMontantImput = data.reduce((somme, facture) => {
                // Vérifie si la propriété 'montant_impute' existe et est un nombre valide
                if (facture.montant_impute) {
                    // Ajoute la valeur au total, en la convertissant en nombre
                    return somme + parseFloat(facture.montant_impute);
                }
                // Si la propriété n'existe pas, retourne la somme sans modification
                return somme;
            }, 0);
            setTotalImpute(totalMontantImput);
        },
        [data]
    );

    return (
        <div>
            <label>Total montant imputé: {totalMontantImpute}</label>
            <ReactDataGrid
                idProperty="id"
                handle={setGridRef}
                style={gridStyle}
                // loading={isLoading}
                reorderColumns={false}
                pagination
                // selected={selected}
                isStartEditKeyPressed={isStartEditKeyPressed}
                pageSizes={[200, 400, 600, 800, 10000]}
                defaultLimit={10000}
                showHoverRows={true}
                editable={true}
                onEditComplete={onEditComplete}
                showColumnMenuTool={false}
                defaultFilterValue={filterValue}
                columns={columnss}
                dataSource={data}
            />
        </div>
    );
}

export default FormTable;
